import m from "../../prime-src/prepare";

export default function RightTop() {
  return (
    <>
      <div className="side2" id="right-top-log-in">
        <div className="button" id="my-id"></div>
        <div className="button" id="choose-lang">▼ Language/언어/語言</div>
        <div className="button" id="choose-timezone">▼ Timezone/시간대/時區</div>
        {m.myIndex === "" ?
        <div className="button darkred"><a className="a-log-in" href="/account/log-in">Log <span className="bold underline">i</span>n / Sign up</a></div> :
        <>
          <div className="button darkred"><a className="a-log-out" href="/account/log-out">Log <span className="bold underline">o</span>ut</a></div>
          <div className="button darkred"><a className="a-log-out-from-all" href="/account/log-out-from-all">Log out from all devices.</a></div>
        </>}
      </div>
      <div className="cBoth"></div>
    </>
  );
}
